import React from "react";
import { Card, Input, Button } from "@nextui-org/react";
import { motion } from "framer-motion";
import { TbCalendar, TbSearch } from "react-icons/tb";

const AltAnalyticsDateFilterCard = ({
  fromDate,
  onFromDateChange,
  toDate,
  onToDateChange,
  onFetchReport,
  loading,
}) => {
  return (
    <motion.div className="qtyContainer alignDivCenter">
      <Card variant="bordered" css={{ mw: "500px", w: "100%" }}>
        <Card.Body css={{ py: "15px", px: "20px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <Input
                type="date"
                label="Start Date"
                labelLeft={<TbCalendar />}
                aria-label="Start Date"
                value={fromDate}
                onChange={(e) => onFromDateChange(e.target.value)}
                size="sm"
                css={{ flex: 1 }}
              />
              <Input
                type="date"
                label="End Date"
                labelLeft={<TbCalendar />}
                aria-label="End Date"
                value={toDate}
                onChange={(e) => onToDateChange(e.target.value)}
                size="sm"
                css={{ flex: 1 }}
              />
            </div>

            <Button
              // shadow
              color="primary"
              icon={<TbSearch />}
              onClick={onFetchReport}
              disabled={loading}
              css={{ width: "100%" }}
            >
              {loading ? "Generating Report..." : "Get Report"}
            </Button>
          </div>
        </Card.Body>
      </Card>
    </motion.div>
  );
};

export default AltAnalyticsDateFilterCard;
